<template>
  <div class="fixed w-100vw h-100vh z-60">
    <div class="absolute w-full h-full bg-0000004D" @click="toggle"></div>
    <div class="relative grid grid-cols-2 bg-white center-absolute md:w-600 lg:w-900 xl:w-1000">
      <button v-if="hasNext" @click="next" class="absolute  bg-orange px-8 py-6 rounded-full right-0 center-y mr-20 text-20 focus:outline-none">
        <i class="fas fa-arrow-right text-white"></i>
      </button>

      <button v-if="hasPrevious" @click="previous" class="absolute bg-orange px-8 py-6 rounded-full left-0 center-y ml-20 text-20 focus:outline-none">
        <i class="fas fa-arrow-left text-white"></i>
      </button>

      <div class="absolute top-0 right-0 mt-40 mr-48">
        <button class="text-black text-24 focus:outline-none" @click="toggle">
          <i class="fal fa-times"></i>
        </button>
      </div>

      <div>
        <img :src="artwork.full_image.lg"
             :alt="artwork.alt_image"
             class="object-cover mx-auto w-full h-full lg:max-h-600">
      </div>
      <div class="my-auto py-18 md:px-28 lg:px-36">
        <a :href="artwork.url" class="block">
          <h1 class="text-orange mb-12 font-bold text-20 lg:text-24">
            {{ artwork.title }}
          </h1>
        </a>
        <h1 class="text-18 mb-20 font-bold lg:text-20">
          <a :href="artwork.artist.data.url" class="block text-black underline">
            {{ artwork.artist.data.name }}
          </a>
        </h1>

        <p class="mb-48 font-bold text-18 lg:text-20">
          {{ artwork.price_with_currency }}
        </p>

        <div class="flex md:mb-24">
          <i class="fas fa-calendar-alt mr-12"></i>
          <div>
            {{ artwork.year_made }}
            <br>
            <span class="text-gray text-14 leading-loose">Year Completed</span>
          </div>
        </div>

        <div class="flex md:mb-24">
          <i class="fas fa-paint-brush-alt mr-12"></i>
          <div>
            {{ artwork.medium_description }}
            <br>
            <span class="text-gray text-14 leading-loose">
              Medium
            </span>
          </div>
        </div>

        <div class="flex md:mb-24">
          <img :src="dimensionIcon" alt="Drybrush Dimension Icon" class="w-16 h-16 mr-12">
          <div>
            <the-artwork-dimension
              is-text
              :depth="artwork.depth"
              :width="artwork.width"
              :height="artwork.height">
            </the-artwork-dimension>
            <span class="text-gray text-14 leading-loose">
              Dimension
            </span>
          </div>
        </div>

        <div class="hidden items-center xl:justify-between xl:flex">
          <div class="w-auto mb-0 mr-18">
            <favorite-button is-text :artwork="artwork"></favorite-button>
          </div>

          <add-to-cart-button :artwork="artwork" :status="artworkStatus"></add-to-cart-button>
        </div>

        <div class="block items-center xl:justify-between xl:hidden">
          <div class="mb-18">
            <add-to-cart-button :artwork="artwork" :status="artworkStatus"></add-to-cart-button>
          </div>

          <div class="w-full text-center">
            <favorite-button is-text :artwork="artwork"></favorite-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArtworkSlideShow from "../../../mixins/artworkSlideShow";

export default {
  name: "DesktopSlideShow",

  mixins: [ArtworkSlideShow],
}
</script>
